import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  template: '',
})
export class SubscriptionHandlerComponent implements OnInit, OnChanges, OnDestroy {
  private subscriptions: Array<Subscription>;

  constructor() {
    this.subscriptions = [];
  }

  protected addSubscription(subscription: Subscription) {
    this.subscriptions.push(subscription);
  }

  protected removeSubscription(subscription: Subscription) {
    const index = this.subscriptions.findIndex((sub) => sub === subscription);
    if (index >= 0) {
      this.subscriptions.splice(index, 1);
    }
  }

  protected clearSubscriptions() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.subscriptions = [];
  }

  public ngOnInit(): void {}

  public ngOnChanges(changes: SimpleChanges): void {}

  public ngOnDestroy(): void {
    this.clearSubscriptions();
  }
}
